"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unique = void 0;
function unique(array) {
    return array.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
}
exports.unique = unique;
//# sourceMappingURL=unique.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-model/dist/utils/unique.js
// module id = 958
// module chunks = 0